import React, { Component } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Input, Button, Table, Card } from "antd";
import { searchEwaybill } from "@/services/api/ewaybillSearch";

import MyTable from "./components/MyTable";

import "./index.css";
class EwaybillSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ewaybillNo: "",
      dataSource: [],
      loading: false,
    };
    this.search = this.search.bind(this);
    this.getDataSource = this.getDataSource.bind(this);
  }
  search(e) {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { ewaybillNo } = values;
        this.setState(
          {
            loading: true,
          },
          () => {
            this.getDataSource(ewaybillNo);
          }
        );
      }
    });
  }

  async getDataSource(No) {
    try {
      const result = await searchEwaybill(No);

      this.setState({
        dataSource: result ? [result] : [],
        loading: false,
      });

      console.log(result, "result");
    } catch (error) {}
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataSource, loading } = this.state;
    return (
      <Card>
        <div className="search-bar">
          <Form layout="inline" onSubmit={this.search}>
            <Form.Item label="快递单号">
              {getFieldDecorator("ewaybillNo", {
                rules: [
                  { required: true, message: "请输入快递单号" },
                  { max: 20, message: "最多输入20个文字" },
                ],
              })(<Input placeholder="请输入" style={{ width: "300px" }} />)}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </div>

        <MyTable dataSource={dataSource} loading={loading} />
      </Card>
    );
  }
}
export default Form.create({})(EwaybillSearch);
